module.exports = __webpack_public_path__ + "img/entryway-lighting.43619fe.jpg";